import React, {useCallback, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {createSelector} from 'reselect';

import * as S from './styles';

import RoomInfo from './RoomInfo';
import GalleriesAndLocationPersuasion from './GalleriesAndLocationPersuasion';

import ReviewInfo from '../HotelDetails/ReviewInfo';

import {updateCurrentRoom} from '../../redux/actions';
import {RoomDataType, HQueryType} from '../../redux/types';

import {calculateRoomPriceData} from '../../utils/details-page-utils';

import {
  hotelStaticMinPrice as hotelStaticMinPriceSelectorFn,
  roomsDataHermes as roomsDataHermesSelectorFn,
  isStaticDataLoading as isStaticDataLoadingSelectorFn,
  bookingWidgetSelector
} from '../../selectors';

import useQuery from '../../../../hooks/useQuery';

// const bookingWidgetSelector = createSelector(
//   [hotelStaticMinPriceSelectorFn, roomsDataHermesSelectorFn],
//   (staticMinPrice: number | undefined, roomsDataFromHermes: RoomDataType[] | undefined) => ({
//     staticMinPrice,
//     roomsDataFromHermes,
//   }),
// );

function PriceNBookingButtonNPersuasion() {
  const isStaticDataLoading = useSelector(isStaticDataLoadingSelectorFn);

  const dispatch = useDispatch();

  const {roomsDataFromHermes = []} = useSelector(bookingWidgetSelector);

  const {getQueryParam} = useQuery();
  const hQuery = JSON.parse(getQueryParam('hquery') as string) as HQueryType;

  const memoisedCalculateRoomPriceData = useCallback(calculateRoomPriceData, [
    hQuery,
    roomsDataFromHermes,
  ]);

  const currentRoomData = memoisedCalculateRoomPriceData({
    hQuery,
    roomsDataFromHermes,
  });

  // fires on first mount and anytime another room is selected
  useEffect(() => {
    dispatch(updateCurrentRoom(currentRoomData));
  }, [currentRoomData.roomPrice]);


  /**
   * the loader is already taken care of in 'HotelDetails' component
   * (it's a clubbed loader, so using it only at one place)
   */
  if (isStaticDataLoading) return null;

  return (
    <>
      <S.GalleryPriceOuterWrap>
        <GalleriesAndLocationPersuasion />
        <S.PriceRatingWrap>
          <RoomInfo />
          <ReviewInfo />
        </S.PriceRatingWrap>
      </S.GalleryPriceOuterWrap>
    </>
  );
}

export default PriceNBookingButtonNPersuasion;
